module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/newpatient/newpatient.component.html
// module id = ./src/app/Pages/tasks/newpatient/newpatient.component.html
// module chunks = main